export enum MilkTankType {
    HORIZONTAL = 'Horizontal',
    VERTICAL = 'Vertical',
}
